// extracted by mini-css-extract-plugin
export default {"columns":"columns---PCw8n","primary":"primary---aIhXF","errorsList":"errorsList---OiNOh"};